/* eslint-disable no-array-constructor */
/* eslint-disable no-unused-expressions */
/* eslint-disable camelcase */
// --------------------------------------------------------------------------------------------------------
//  0.3.0 - 2024-12-18
//    - Taken from Desktop app to be used here on mobile
//
//  Ver 0.2.0 - 2022-09-07
//    - Wanted to experiment with smaller map for the vehicel TimeLine so split this to allow
//
//
//  Ver 0.1.3 - 2022-08-29
//    - Fixed error on plotting or iterating through exceptions
//
//  Ver 0.1.2 - 2022-08-16
//    - Errors in Marker array, chanced the Googke Map canvas to: map_canvas2
//
//  Ver  0.1.1 - 2022-04-26
//    - Converted to a class with constructor.
//    - Modified to class
//
//  Ver  0.0.2
//      -  added ability to plot fixed assets
//
// --------------------------------------------------------------------------------------------------------

//
// this declaration is used for testing class in Node.js
//
/*
module.exports  =   class google_maps_all {
  constructor() {
  }
}
*/

// module.exports  =  class google_maps_trip {
export default class google_maps_trip {
  constructor (baseUrl, axios, google, debug, document, canvasName) {
    this.document = document
    this.baseUrl = baseUrl
    // this.moment = moment;
    this.axios = axios
    this.google = google
    this.debug = debug
    this.canvasName = canvasName

    this.map
    this.icons
    this.polyPoints
    this.markers
    this.options
    this.infoWindows
    // Constants:
    this.fillColor = '#0000FF' // blue fill
    this.lineColor = '#FF0000' // Red line
    this.opacity = 0.7
    this.lineWeight = 4
    this.ICON_START = 7
    this.ICON_END = 8
    //
    // Used: https://www.base64encoder.io/image-to-base64-converter/
    //
    this.exclamation =
      'data:image/png;base64,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'
    this.resultset_last =
      'data:image/png;base64,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'
    this.resultset_next =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAEdSURBVDjLY/j//z8DJZiB6gY0rH7xpW7li3YKDHj1v2bli38lix61k2VA5fJn/9eeeP+/fcOL/wlT7/aRbEDegkf/Vxx/93/xobf/S5c8/u/ecm0eSQYkTX/4f+HBN/8nbX/xf+bul/8Tp9/9r1N0dgnRBgT33QZqfPW/YdXj/42rH//v2vjkv3fHtf9SScceEWWAc8u1/xO2Pv9fsvjB//IlD4CGPPrvXH/5v2Tksc1EGWBaful/+/on/4sW3gfGxsP/9lUX/ksEH1gj6rqdhSgDlPPO/q9b8fB/5bIH/23LL/wXD9i7kqRAlEo6+b908f3/NiXn/4t57V1EcjRKRB75b1145r+o684FZCUkMb8D/0Uct88euMxEKgYA7Ojrv4CgE7EAAAAASUVORK5CYII='
    this.left =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wCHQ0hIM6yDK4AAAAdaVRYdENvbW1lbnQAAAAAAENyZWF0ZWQgd2l0aCBHSU1QZC5lBwAABEFJREFUWMPtmU1oHGUcxn/PZttYDdpWRRpasShqD0pnVKhaIz2IFpmhFE8BBU/ao7cWeigiXjwVRL2Ip9JD/YDdSloFq1akCs5Q0IoVq8WPtRqrkhj7FR4PfadO4maTbbfZDfi/7CzvzDvPPPP8PwcWoKlTG9WiSMBioApUACQZmLR9Ns3zcz0BuhZFA5JusL1M0i3AzcAK4GrbfZJOAb/Z/l7Sl8AJ26OSfkmybHJeQdfjeLXtuyQ9AAwBawFsI/27pW0C48XxqKRPbH8g6WPgcJJl45cVdC2KBiUN206A9YUMCowqI55qLt8rPEBD0n7gTWBvkmXuOOhaFD0uaYvte4BqYM8BZzsPb0Clt3DC9j5gR5rn33UEdD2OFwOvAo8Cy4IE3AEnng7+qO3taZ7vuSTQ9TheCowEdvuCBDoadcLbUiBjHHg2ybIXWl3T10IO10s6AMSSKiXNqqMx9zzgQs/9wNDw4OCi3Y3G+20xXY/ja4C9wdnm3Wz/DWxL83xns/VKE8BV4EXb621TYmG+ABtYAmyvx3E6J9C2nwQ2Be22CmOXJ0WfNwPXAdvqcbyqJehaFN0OPA0MdANwOY6HW68DnqrHsZqCrkXRIkmbJcVBEV0B3MQ5h4G7Z2J6le0nwrmmy1aEQWC17YdrUbSoWKsG56sA62zf1m4c3jAycuH4wMaNnQZeJLHNknYB315g2vYAkJQyVU+VzpIiYPUUeUi60vZDnc52HXbOoXoc95eZXiHp2vmOyW1KZZ3tJQDVEE7uDGFG9K6tkdQPULVdkXRTL+MNAlhZBI5CHssXQD9bkdRXjtN9Pd19T1NBAXqih32QEjYT2iYDPy8AeYwB54qMaNtH59CcdtuOAWcBKkmWWdIXkno95B0GTpc1PWb7cKkI7yk9B0IPAhPlkDcuqd7pUVmHupii/fq0mEpVANI8PwXsK7HcE2yX1Fq3/VOzevor4K1pIabbLCsQWEvzfPQ/oJMsGwV2SZoIQxR3m+UAYT/w3ow9oqR3bb/eA9ouWD4p6bU0zxvlxWr5T5JlY7Uo2hnKwFuZNjhsp4uZyWbrbgpZBD2/AeyZdYSQ5nlm+zngT9vdkEkB+BCwtdk0dUYW63G81fYOoH++ck5prndM0lCSZT82O2/G6m53o/HR8OBgn6R7bVcvZ5ovwIatjwMPpnn+Q8vGsZXV43gL8DywtINj3ikOF/Y9ZzsHHknz/GTLwnq2XZMse9l2YvsQcDro/FITUOEqxV6/2n4JuH82wG2FtfBR6Bnbj0m6w3b52jnJZvo3GeB32wclvZJk2cicPbVdisK8b5OkDbbvkzTQLIsWyaH8W7KvbX8o6R3g7STL/mp7GHIxVouilZLW2F4LRMAa4EZg+bTa4YztBvCNpM9tfwYcAY6keT5x0ROcS7EwUlsWHPUq4IqQtARMSjoTqrQx4I80z8f53xaI/QPlpyewSFEc8QAAAABJRU5ErkJggg=='
    this.right =
      'data:image/png;base64,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'
    this.bump =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcCAIAAACPoCp1AAAABnRSTlMAwADAAMCNeLu6AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAD9ElEQVR4nLWVW0wcZRTH/+ebYXcLS3e3LLBrYZc1fTHUBNiHBh80tdim+NQHXqgm1YdGmwIND0SUYoOJ2KQQLYstlwaoNlbRh2rCxYZSGkwTmtBQSylKqkGachExJbCyO98cH4bLlhJcCv6TyXwzc875ncskhxwOh9frxf+jkZER1e/3l5WVRenguXgxqb39jyNHJg4ciMa+uLhYRJ9O/NC9lJaW2EePfGfPWiYmovSKFkDMvkBAlRKAaW7O9/m5LQYkXuuyD95bfnT03th+9+6WAZRgMLWhMfKNKvW0hkZi3hqAp7klbnwcQFhVg7U1usUCIP7nO87u61sAsP76i/u7b40zHz5seeeYdqIIgKLr3rrzSvCfzQGY0wK1qqYBCCXsEJUfE0gpeW/B7WZC7MREyuXLmwI4e39yDAwYZ6qoUF0uBit2G5WXgwHA3fqNZerPZwQooZCn7jwBAELZ2erRo4DxBPXtt0Iv7mbAND+f2tL8jICdX34R93AMQNhsokCAFHXFLcYkKiuZCEBiR0fs6OiGAdYHD1K++poYAPj4cTUzc3V9Bw+G973KgKJpvtrajQFI133V1Wo4BCDs9ajlH9LTniSUyk9YUQhw9PUl3OjZACC5vd02OAhACkJVlYiPX9NM8ftlfj4AAqfVNwgpowLEPH7saWwUzAC0nNfUQ4fWjA6AAFFRocXFEiP24VhSZ2dUAG9Tk/nvGQCa2SyqzxCt9yMIj0cvKGACGKlNzUow+B8A68iI6/sfjNnqxSfUF3avEx0AEaklJTI5GSDL1GTKpUurDNQnrJl9gYCQGoDwrl0x75dRxHD7+vp6e3tDoZDT6czLy7PZbIs52h3aqVPKu8eIsbO1dSr39fnn3CtuOTk515c09EGZRqQDmhALP3bqui6llFLOzMwUFBQIsVKux+Npa2uTS9JCC0F/pg5IwvjevcsBs7KyVnzUuTlP3TnBzIRwfr66L2d2dtZqtVqt1qSkpJqaGl3Xl41HR0dzc3ONr4WFhaTG0JkqKQQxEnp64oeH12iR98IFy/RfAKTdoZw+TUQmkylyXfOSiCiymoyMDAJiXn5F279f6egQzN66usHqao4EbB+677pyxVgg8uRJk9sFwGw2l5aWrhqaAcDTIsJHFfLqVUVK++3bO27enM7OXgQI5uc/+1SREoCuCGX4vl5UBIAYTMbwAYAJIMJydOMesdMEwAkJmJwksKe+fmbPnkWAs6vLutQ1IXVRV79GghsRMeJ+/83Z1WVQYb91K5rtuiEJRuK1bhgVjL3xJhNsA3fMs7NGzTrW6vJieosX1s1Jbts2/VI2urvJ5XKlp6ev+AJ4orGbUn9//7/d15TI9UPtOwAAAABJRU5ErkJggg=='
    this.dot1c =
      'data:image/gif;base64,R0lGODlhEAAQAMQfAP9ra/8mJv8XF/+bm7cAAP+6ulcAAP8AAIcAAKUAAOMAADQAAGcAAP83N5kAAPEBAcgAAP9bW/8NDUcAAP9NTRYAANEAAAUAAP0FBdoAACkAAHkAAPsAAP9AQP+NjQAAACH5BAEAAB8ALAAAAAAQABAAAAWf4CeKlzYZyzWu37U4z3FwEKOul2HJvAxVoxxBccAIBBIJ5pABfjSIoZECiEQakgOiZYhmMA2AZ1AYNA6PSqWbgDwCVE+5IzOsNw7CVxDoRCgBMgxrDAgJeg8YEkhLHAYXJ4WHFgoPHJcPGSkaBgaFeRAWGaMWCUAVC5EbhocEBAkTJBqpqgi2GzZBswu8J50TN0EVu7waFcEsFxdqyiwhADs='
    this.dot5c =
      'data:image/gif;base64,R0lGODlhEAAQAMQfABgY1wkJagEBMFeH/yEi/njI/xMStzVI/4Tk/0Zl/x0d/QgIVxAQpSw2/xgYyG+5/xgY4ygo/w0NhBwg8SYr/0pz/xsb8gYGRgEBFgAABRAQnFuU/y88/yAm+w8PjQAAACH5BAEAAB8ALAAAAAAQABAAAAWi4CeKGXYtQjauXyZolkIQTqCu2QLIRORHDswoZ4AoIpxkg0IBCD8CSZHAqQyuCU7E07pIAZ3D5lFAFBIRCwYTkDAck0NlbE5QFAvMIqAxgDkHCQMVBzMBem0MfhMdFA0NEQR4GScBHooAEDEKChYAFy4LexJ9DgCnpxpCGAKVEh4aigYGGhckAq2urx4SNkO4uBcnoqAsJcDAGDcsLSXKyyIhADs='
    this.accident =
      'data:image/png;base64,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'
    this.lock =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAflBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///+CCKX+AAAAKHRSTlMAEl+h0fEqo/gLkvwo1zTt020KbAJFATed3/0M/sfaUxARWOIb5rXG2MiiGgAAAAFiS0dEKcq3hSQAAAFVSURBVFjD7ZbZdoJADIaBYVdUFssqUB1t3v8Jq4UBKYyznfZG/ss/kw9IciZoGlW6gUwLwDKRoWvish0XBrmOLZju+RuYaON7IvnbAGYKtvz5uz0saL/jfv5i/p3A+Q5eABQFfHXwgSqfq39j/Q+hHUV2eBh7wdNNZ2h+nHROEg8j4bDzdXLYPY7mcTDZM2mQh8XPbkxcgwlA5PuTZzchdUBMgNmfDKd22NsmE2D1J3/V2+5ti5X/QT42mvoR8ZlvQDu4AlbAOwHSLC+AoSLPUkp6iSrgUoXKxfwTcOtUvrjLuLRws6WVCKCa1yEDIWUzQC4GyGeAQgxQUAeIV28DqJu2bWp5QP2zzPVaGtB0oUYa0HahVhXwKQ04d6GzNOCCHxF8kW/j9RG5qgzS68gK+B/AfRCwEuCG8Y0ToHypKl/ryotFebUpL1eh9f5V/sUPhuQvzjfuEERRwHe8VgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxMy0wNy0zMFQxMToyMDo1MS0wNDowMPX80ugAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMDctMzBUMTE6MjA6NTEtMDQ6MDCEoWpUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAABJRU5ErkJggg=='
    this.rpm =
      'data:image/png;base64,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'
    this.speed =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAGGUlEQVR42rVWe2xTZRT/ndvedn3YdY9ug40NJmPARJ4yh7Bh5JFNwnw/MAYUY3wkBvjLAGoiDGOCmEgQUAOJAhpJZFHjIjBneW0LAzYcA/bosm4rY2u70q3r67afpxclGiQajV9yc2/v/b7zO+f3O48S/udFf7dh+/btJfPmzSvX6XQzFUWZEAwGMTo62uvz+Vqam5t/2LlzZ8O/Ajhy5MhKNrzFaDTO6OrqonPnzmFoaAjxeBxmsxk2mw1arRZer/eX7u7uzTt27Pj2HwGsWbPGsHnz5k/y8vKeq66uRm3NcUzUW2lufqFI18gEIuEVCtrd19AZcJMl1SIMBgM8Hs/BEydOvFxfXx+8I8Dq1auNVVVVNez1orc3vkXFlmxRmpoGXOsjT8Av0iQNhRVFKBoJaca7gAl51BANC/v1LugNevL7/faGhoYKjnbsLwHa2tq+zMzMfGbjug14KbcIyd4h+MYCmGQwYiQchlUnQ8tHEjTFhUA7f8u3WOHOycbnXif8oRBYm68OHTr07G0ABw4ceLKiouLr997dIlaORJFuMJExyt4qCiyyTBKEYOOkEUJoeL/El+DzEf7tSZLhlwXtDwfEdY8Xg4ODT9fW1h6+BVBWViaxSJedTucU57ZtYsmM++GLRinXaBIJQyFZRx3J6cKdZGQFILJCAcz0e5Aci1KcEVt8PkywGOnY0FVxMjkX/S5XB2fYNJfLFVcBNm3a9FBlZeXxbz7di4qTdpgXPowUrax66WKu6zNzoRBxDFD9ZqehF3FU+HqREwkgqgMcI0HEOppwuPBetDr6wc4uaW1trVUB9u3btyMlJWXd5W1bqMTRJyyVTyNZp6eAVhZHs++GwtQkLPOixE3DYZh1MaTIUVo07BKaYBRX3H5Kaq4RzTNm4UzUSpzaH3JGbVABdu3aVceFVBaseofyBzxi0qqXoWOA8ykZotNsxU3DNwFkpiTDHEGqQYFBlihHB5HmH4PeM0bB/Z+Kc9l5OD5rAV24cOFnTtsHVYCtW7de0ev1U1I4gqxhv8i87wGY55bQMVuOGNbqftNKiInZEk3N04i0ZBlDvhic1xUadQTECy4XQhcaydFUL0LTc/HFQyuJNbhqt9unqgDr169v58osSH//PeTeGIFekpBc/hh+nlWCG6xFgvPxmTLmFJlwxRGEoycIJaaGhAwlijcuNSFa8w28nL4DRXn4YvnjOHv2bDtHUKgCrF279tTkyZMX4KMPaMrQsDDxaY0kUdPyR8TI7AWsgEQ3GbpFlZra8XiMCpobxIvHvkOInyN6vWiYX4STpeXEaXqai26hCrBq1aqPWeRXM883YUZ9I4yJw3z1cgvYM3U6xmdPQmpqBgxccAnbweAo3O4B9PZ24WBHO+7lImzVaDExpuD7p8pxypaPurq63Vy4r6kAy5YtWxmJRKqXzJ1DBZ/tFTF/EFqdjn6YXiTqx0bBxUbi5vr9rtIjcZRLJUlsdTohxeOkn5Iv9j//LI6eOU+NjY2Vbrf7WxWgoKBAzsrK6i4pKcnW/3hUmF3X0DhzNgU0GhFm7wYG+ml0dOQWQOJMUlISrFarSpklEsGbzh5Slj4gmrhImR4X0zMpyutWqygtLX2Fm9XuyhUr8JP9DBvQq+04FouheDrg46iudo8keMfE8TKMegmNl6F+j0TC0MlGPPH4CpxmijlFX+3r69vzp17EEUjjxo07ZjKZHiwuLkFr61WKx6NCo9HgtUfjVDwtJi47whQKh0TWXTdw5pKEA3VWinK/MpmSMX/+HBoYcAmu3rqWlpalDBy/rZvm5+enM692FnzawoWLqKOjRxiNJjxV6qNp4/rF2bYojYXCoiDLiysDE1B7qYDYezF79j1wOLoS1dt28eLFslAo5L7jwMnJybExyGEWvWzx4sVc0UnwDQ8jL0vGeJustuq+6yH0uwVsGRkwmYzgokoMHHtnZ+cTrJn7j/b+cmRaLBYND53XefMmNmgrLCwkfic4bGJd1AnGDqCnp4dpjA/y2Kzia1csIcg/ncmJxYYMHM0jnKblnBCziCiDexZkWR7k980MUsN0VDNI8E42/vZfxX9dvwJDpyRGeVd1pwAAAABJRU5ErkJggg=='
    this.engine =
      'data:image/gif;base64,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'
    this.greenBall =
      'data:image/gif;base64,R0lGODlhEAAQAMQfAABsAC/3L0//T6vPqwAqAAbCBsXLxQKmAo6Zjoe4h1CDUNTj1ASXBOPy4/D08Ons6QGBAaKzojZPNgBXADKtMgayBgBBAB/hHwAXABG6Efv8+/b49iA8IJfSl3TAdP///yH5BAEAAB8ALAAAAAAQABAAAAWY4CeK2jIMyzaunzYoEMQwVKeujjLJzOEflMZIowPIKoVkpUJxiCKWibFyCVgvhYPns5FEjZmAYCy4HBgNA+ELOVTJZsYgsmYzMtVLhgFJ0NcTUjE9ZzEJBhh1gQCMMTEAEQ4cBJRRi4yMEwsfCImVloETFgoiXRiedRaqHA8jDxKnp5SUHJsrGwgcsYkIrSwiDgYICAZOKyEAOw=='
  }

  initialiseTrips (TripPlot) {
    try {
      var tripPoints = new Array()

      this.createTripIcons()

      var EndArray = 0

      this.markers = new Array()

      var Points = JSON.parse(TripPlot.Points)

      var violations = JSON.parse(TripPlot.Violations)

      for (var i = 0; i <= Points.length - 1; i++) {
        var lat = Points[i].lat
        var lon = Points[i].lng
        if (lat === 0 || lon === 0) {
          // ignore this point do not push to array
        } else {
          tripPoints.push(new this.google.maps.LatLng(lat, lon))
        }
        EndArray = i
      }

      var StartTime = TripPlot.Beg
      var EndTime = TripPlot.End

      /*  var myOptions = {
        zoom: 12,
        mapTypeId: this.google.maps.MapTypeId.ROADMAP
      }; */

      var myOptions = {
        mapTypeId: this.google.maps.MapTypeId.ROADMAP
      }

      this.map = new this.google.maps.Map(
        this.document.getElementById(this.canvasName),
        myOptions
      )
      // debugger;
      this.map.ref_GoogleMapsTrip = this

      this.plotMarker(tripPoints[0], this.icons[7], 'Trip Start ' + StartTime)

      this.plotMarker(
        tripPoints[EndArray],
        this.icons[8],
        'Trip End ' + EndTime
      )

      for (var idx = 0; idx < violations.length; idx++) {
        var desc = idx + ' ' + violations[idx].Desc
        var violationId = violations[idx].Id
        var latlng = new this.google.maps.LatLng(
          violations[idx].Lat,
          violations[idx].Lng
        )

        this.plotMarkerArray(idx, latlng, this.icons[violationId], desc)

        this.google.maps.event.addListener(
          this.markers[idx],
          'click',
          function () {
            this.closeInfoWindows()
          }
        )
      }

      this.map.setCenter(tripPoints[0], 2)
      this.drawCoordinatesOnPoints(this.map, tripPoints)
      this.zoomCoOrdinatesOnPoints(this.map, tripPoints)
      // debugger;
      //
    } catch (e) {
      console.log(e)
    }
  }

  closeInfoWindows () {
    var len = this.infoWindows.length
    if (len > 0) {
      try {
        for (var i = 0; i < len; i++) {
          this.infoWindows[i].close()
        }
      } catch (ex) {
        console.log(ex)
      }
    }
  }

  // plot markers and create an array
  plotMarkerArray (i, posLatLng, iconImage, titleText, markerType) {
    // Shapes define the clickable region of the icon.
    // The type defines an HTML &lt;area&gt; element 'poly' which
    // traces out a polygon as a series of X,Y points. The final
    // coordinate closes the poly by connecting to the first
    // coordinate.
    var shape = {
      coord: [1, 1, 48, 48],
      type: 'circle'
    }

    var zIndex = 50

    if (markerType > 5) {
      zIndex = 150
    }

    this.markers[i] = new this.google.maps.Marker({
      position: posLatLng,
      map: this.map,
      // shadow: shadow,
      icon: iconImage,
      shape: shape,
      title: titleText,
      zIndex: zIndex
    })
  }

  // Initialise an array of Icons
  createTripIcons () {
    try {
      var icoSize = new this.google.maps.Size(48, 48)
      var icoAnchor = new this.google.maps.Point(6, 20)
      var icoOrigin = new this.google.maps.Point(0, 0)
      this.icons = new Array()

      this.icons[0] = new this.google.maps.MarkerImage(
        this.exclamation,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[1] = new this.google.maps.MarkerImage(
        this.exclamation,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[2] = new this.google.maps.MarkerImage(
        this.resultset_last,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[3] = new this.google.maps.MarkerImage(
        this.resultset_next,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[4] = new this.google.maps.MarkerImage(
        this.left,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[5] = new this.google.maps.MarkerImage(
        this.right,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[6] = new this.google.maps.MarkerImage(
        this.bump,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[7] = new this.google.maps.MarkerImage(
        this.dot1c,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[8] = new this.google.maps.MarkerImage(
        this.dot5c,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[9] = new this.google.maps.MarkerImage(
        this.accident,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[10] = new this.google.maps.MarkerImage(
        this.lock,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[11] = new this.google.maps.MarkerImage(
        this.lock,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[12] = new this.google.maps.MarkerImage(
        this.lock,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[13] = new this.google.maps.MarkerImage(
        this.rpm,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[14] = new this.google.maps.MarkerImage(
        this.speed,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[15] = new this.google.maps.MarkerImage(
        this.engine,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[16] = new this.google.maps.MarkerImage(
        this.greenBall,
        icoSize,
        icoOrigin,
        icoAnchor
      )
      this.icons[101] = new this.google.maps.MarkerImage(
        this.exclamation,
        icoSize,
        icoOrigin,
        icoAnchor
      ) // Alarm Triggered
      this.icons[102] = new this.google.maps.MarkerImage(
        this.exclamation,
        icoSize,
        icoOrigin,
        icoAnchor
      ) // External battery low
      this.icons[103] = new this.google.maps.MarkerImage(
        this.exclamation,
        icoSize,
        icoOrigin,
        icoAnchor
      ) // External battery disconnected
      this.icons[104] = new this.google.maps.MarkerImage(
        this.exclamation,
        icoSize,
        icoOrigin,
        icoAnchor
      ) // Internal battery low
    } catch (e) {
      console.log(e)
    }
  }

  //
  //
  //
  plotMarker (posLatLng, iconImage, titleText) {
    //
    // Shapes define the clickable region of the icon.
    // The type defines an HTML &lt;area&gt; element 'poly' which
    // traces out a polygon as a series of X,Y points. The final
    // coordinate closes the poly by connecting to the first
    // coordinate.
    //
    try {
      var shape = {
        coord: [1, 1, 1, 20, 18, 20, 18, 1],
        type: 'poly'
      }

      var marker = new this.google.maps.Marker({
        position: posLatLng,
        map: this.map,
        // shadow: shadow,
        icon: iconImage,
        shape: shape,
        title: titleText,
        zIndex: 50
        // zIndex: beach[3]
      })

      return marker
    } catch (e) {
      console.log(e)
    }
  }

  drawCoordinatesOnPoints (Map, Points) {
    try {
      //
      var polyShape = new this.google.maps.Polyline({
        path: Points,
        strokeColor: this.lineColor,
        strokeWeight: this.lineWeight,
        strokeOpacity: this.opacity,
        zIndex: 500
      })

      polyShape.setMap(Map)
    } catch (e) {
      console.log(e)
    }
  }

  ///
  /// zooms to the bounds in the global variable: polyPoints
  ///
  zoomCoOrdinatesOnPoints (map, points) {
    try {
      //  Create a new viewpoint bound
      var bounds = new this.google.maps.LatLngBounds()
      //  Go through each...
      var pointsLen = points.length
      for (var i = 0; i < pointsLen; i++) {
        //  And increase the bounds to take this point
        bounds.extend(points[i])
      }
      //  Fit these bounds to the map
      map.fitBounds(bounds)
    } catch (e) {
      console.log(e)
    }
  }
}
